<template>
  <div class="target_wrap">
    <div class="target_title">
      <span>目标画像人群贡献订单</span>
      <el-button size="mini" @click="toImg('target_pic', '目标画像人群贡献订单', taskChildData.taskName)" :disabled="piePic.length === 0">下载图片</el-button>
    </div>
    <div class="target_people">总计贡献<span>{{otherData.curTaskOilCnt | isNullOr0}}</span>笔订单，共计<span>{{otherData.curTaskAmount | isNullOr0}}</span>元, <span>{{otherData.curTaskLitre | isNullOr0}}</span>升</div>
    <div class="target_time">统计时间：{{taskChildData.startTimeFormat || '-'}}至{{taskChildData.endTimeFormat || '-'}}<span v-if="taskChildData.status === 4">(持续更新中)</span></div>
    <template v-if="piePic.length > 0">
      <div class="target_change">
        <el-radio-group v-model="type" style="margin-bottom: 10px;" @change="handelChange">
          <el-radio-button label="1">加油升数</el-radio-button>
          <el-radio-button label="2">加油金额</el-radio-button>
          <el-radio-button label="3">加油笔数</el-radio-button>
        </el-radio-group>
      </div>
      <div class="target_pic" id="target_pic">
        <pie :id="'target'" :data="piePic" :type="type"/>
      </div>
    </template>
    <template  v-else>
      <noDataPic/>
    </template>
  </div>
</template>
<script>
import noDataPic from './noDataPic'
import pie from './targetPeoplePic'
import mixinDown from './mixin'
export default {
  props: {
    userOrderData: {
      type: Object
    },
    taskChildData: {
      type: Object
    }
  },
  mixins: [mixinDown],
  components: {
    pie,
    noDataPic
  },
  data () {
    return {
      type: '1',
      piePic: [], // 渲染的数据
      otherData: {},
      litreData: [], // 升数数据
      amountData: [], // 金额数据
      oilCntData: [] // 笔数数据
    }
  },
  watch: {
    userOrderData: {
      handler (newValue) {
        this.piePic = []
        this.litreData = []
        this.amountData = []
        this.oilCntData = []
        const { curTaskLitre, curTaskAmount, curTaskOilCnt, taskStartTime, taskEndTime, orderList} = newValue
        this.otherData = { curTaskLitre, curTaskAmount, curTaskOilCnt, taskStartTime, taskEndTime }
        orderList && orderList.forEach(item => {
          this.litreData.push({ value: item.litre, name: item.orderTypeName, amount: item.amount, oilCnt: item.oilCnt })
          this.amountData.push({ value: item.amount, name: item.orderTypeName, litre: item.litre, oilCnt: item.oilCnt })
          this.oilCntData.push({ value: item.oilCnt, name: item.orderTypeName, amount: item.amount, litre: item.litre })
        })
        this.piePic = this.litreData
        this.type = '1'
      },
      immediate: false
    }
  },
  methods: {
    handelChange (val) {
      this.type = val
      if (val === '1') {
        this.piePic = this.litreData
      } else if (val === '2') {
        this.piePic = this.amountData
      } else {
        this.piePic = this.oilCntData
      }
    }
  }
}
</script>
<style scoped lang="less">
.target_wrap{
  padding: 16px;
}
.target_title{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  >span{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }
  .target_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.target_people{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  >span{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3377FF ;
  }
}
.target_time{
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.target_change{
  margin-top: 20px;
}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #3377FF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
.target_pic{
  padding: 0 0 10px 0;
  margin-top: 10px;
}
</style>